import React from 'react';
import PropTypes from 'prop-types';
import styles from './CardListIndex.module.scss';
import isEmpty from '../../utils/isEmpty';
import CardIndex from '../CardIndex';

const CardListIndex = ({ items }) => {
    return (
        !isEmpty(items) && (
            <div className={styles['CardListIndex']}>
                <div className={styles['CardListIndex__Container']}>
                    <div className={styles['CardListIndex__Inner']}>
                        {!isEmpty(items) &&
                            Object.keys(items).map((cards, idx) => {
                                return (
                                    <CardIndex
                                        key={idx}
                                        type={cards}
                                        cards={items[cards]}
                                    />
                                );
                            })}
                    </div>
                </div>
            </div>
        )
    );
};

CardListIndex.propTypes = {
    items: PropTypes.object,
};

CardListIndex.defaultProps = {
    items: {},
};

export default CardListIndex;
